import React from 'react'
import { Content } from './Content'
import { Header } from './Header'

export const MaternalView = (): JSX.Element => {
  return (
    <>
      <Header />
      <Content />
    </>
  )
}
